function injectStyle (ssrContext) {
  require("!!../../node_modules/.pnpm/extract-text-webpack-plugin@1.0.1_webpack@1.15.0/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6a32b49f\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?sourceMap!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/selector?type=styles&index=0!./info-table.vue")
}
var Component = require("!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/selector?type=script&index=0!./info-table.vue"),
  /* template */
  require("!!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6a32b49f\",\"hasScoped\":false}!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/selector?type=template&index=0!./info-table.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/info-table.vue
// module id = 182
// module chunks = 4 7